import { Component } from '@angular/core';
import { YukkApi } from '../../../../service/yukkapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
// import { yukka } from '../hierarchy'

@Component({
  selector: 'app-board-entity',
  templateUrl: './board-entity.component.html',
  styleUrls: ['./board-entity.component.scss']
})
export class BoardEntityComponent {

  treemapdata: any;
  loading: boolean;
  myOrder: string;
  myArray: any = [];
  hierarchies: any;
  previousValue: any;
  params: any;

  constructor(
    private yukkApi: YukkApi,
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.params = params;

      if (params.sort) {
        if (params.sort === 'senti') { this.myOrder = '-sentiment'; }
        if (params.sort === '-senti') { this.myOrder = 'sentiment'; }
        if (params.sort === 'abc') { this.myOrder = 'entity.name'; }
        if (params.sort === '-abc') { this.myOrder = '-entity.name'; }
        if (params.sort === 'trend') { this.myOrder = '-sentiment_delta'; }
        if (params.sort === '-trend') { this.myOrder = 'sentiment_delta'; }
      } else {
        this.myOrder = '-trend';
      }

      if ((params.id && params.type && ( params.type !== 'event' ) ) || params.portfolio) {
        if (routing.reFresh(params, this.previousValue, ['type', 'id', 'time', 'lang', 'feed', 'categories', 'continents', 'countries', 'ranks'])) {
          this.treemapdata = [];
          this.loading = true;
          this.yukkApi.treemap(params).subscribe(result => {
            this.treemapdata = result.treemap.children;
            this.loading = false;
          });
        }
        this.previousValue = params;
      }
    });
  }

  goMap(entity) {
    let path = ['../chart'];
    if (this.routing.isIframe()) { path = []; }
    this.router.navigate(path, {
      relativeTo: this.route, queryParams: {
        type: entity.type,
        id: entity.alpha_id,
        tag: null,
      },
      queryParamsHandling: 'merge'
    });
  }

}
